import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { get } from 'lodash';
import { PuffLoader } from 'react-spinners';

import Header from 'components/Header';
import Footer from 'components/Footer';
import Decline from 'components/Icons/Decline';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';
import {
  checkPreviousAction,
  resumeApplicationAction,
} from 'actions/workflow';
import imgError from 'assets/icons/error.svg';

import style from './style.scss';

const CreditFreeze = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [errorMsg, setErrorMsg] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const applicationId = useSelector((state) => get(state, 'workflow.attributes.entityId'));
  const key = searchParams.get('key');

  useEffect(() => {
    if (!key) {
      navigate('/fsl/application', { replace: true });
    } else if (!applicationId) {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/${key}/checkin`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    }
  }, [window.location.search]);

  const resumeApplication = () => {
    setIsLoading(true);
    dispatch(resumeApplicationAction({
      key,
      activity: 'continuefromcreditfreeze',
      workflowType: 'fsl',
      success: (res) => {
        const route = get(res, 'state.url', get(res, 'data.url'));
        if (route) {
          navigate(route);
        }
        setIsLoading(false);
      },
      fail: (error) => {
        setIsPopupVisible(true);
        setIsLoading(false);
        if (error && error.response && error.response.data && error.response.data.errorMessages && error.response.data.errorMessages.length > 0) {
          setErrorMsg(error.response.data.errorMessages[0]);
        }
        console.log('error', error);
      },
    }));
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
    setErrorMsg('');
  };

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
        <div className="grid-container fluid borrowers-message">
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              {applicationId ? (
                <div className="cell small-12 large-10 large-offset-1" style={{ textAlign: 'left' }}>
                  <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
                </div>
              ) : null}
              <Column className="small-12 large-10 large-offset-1">
                <Decline className={style.user} />
                <h2>Your Credit Is Frozen</h2>
                <br />
                {isLoading ? (
                  <PuffLoader
                    color="#3989e3"
                    size={100}
                  />) : (
                    <Fragment>
                      <p style={{ marginBottom: 0 }}>The following actions are needed so that a decision can be made on your application:</p>
                      <b>To remove the freeze from your credit report, please visit the <a target="_blank" rel="noopener noreferrer" href="https://service.transunion.com/dss/login.page?">TransUnion Service Center</a> or call TransUnion at <a href="tel:+18889098872">888-909-8872</a>.</b><br />
                      <b>After the removal of the credit freeze, please click on this <a onClick={resumeApplication} href="#">link</a> to continue your application.</b>
                      <hr />
                      <p>You must complete the above actions within 30 days; otherwise, we will be unable to proceed with this credit application.</p>
                    </Fragment>
                )}
              </Column>

            </Grid>
          </div>
        </div>
        <div className={cn('reveal', style.reveal, !isPopupVisible && style.invisible)}>
          <div className="card-content error-modal security-error">
            <img src={imgError} alt="" />
            <p>{errorMsg || 'Please try again.'}</p>
            <Button
              className="button danger"
              style={{ marginBottom: 0 }}
              onClick={handleClosePopup}
            >
              Ok
            </Button>
          </div>

          <button className="close-button" data-close aria-label="Close reveal" type="button" onClick={handleClosePopup}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default CreditFreeze;
